import dynamic from "next/dynamic";
import { useEffect, useMemo, useRef, useState } from "react";

import { useStateContext } from "@/context/context-provider";

import styles from "./background-overlay.module.css";

const LiquidEther = dynamic(() => import("@/components/animated/liquid-ether/liquid-ether").then((m) => m.LiquidEther), { ssr: false });

export const BackgroundOverlay = () => {
    const { isMobile } = useStateContext();

    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const shouldRenderEther = useMemo(() => {
        return isClient && !isMobile;
    }, [isClient, isMobile]);

    const hasMountedRef = useRef(false);

    if (shouldRenderEther && !hasMountedRef.current) {
        hasMountedRef.current = true;
    }

    return (
        <div className={styles.backgroundOverlay}>
            {shouldRenderEther && hasMountedRef.current ? (
                <LiquidEther
                    colors={["#5227FF", "#FF9FFC", "#B19EEF"]}
                    mouseForce={10}
                    cursorSize={40}
                    isViscous
                    viscous={30}
                    iterationsViscous={16}
                    iterationsPoisson={16}
                    resolution={0.25}
                    isBounce
                    autoDemo
                    autoSpeed={0.5}
                    autoIntensity={2}
                    takeoverDuration={0.25}
                    autoResumeDelay={500}
                    autoRampDuration={0.6}
                />
            ) : null}
        </div>
    );
};
